import { AdvancedSelect } from '@orobix/orobix-fe-components'
import i18n from 'i18next'

import { FilterButton } from '../../../components/FilterButton/FilterButton'
import { FilteringValue } from '../../../types/filtering'
import {
  ABORTED,
  CREATED,
  DONE,
  FAILED,
  RUNNING,
} from '../../../types/optimizationProcesses'

type FilterByStatusProps = {
  filter: FilteringValue
  onFilter: (value: FilteringValue) => void
}

const renderFilter = ({ filter, onFilter }: FilterByStatusProps) => {
  const options = [
    { label: i18n.t('Queued'), value: CREATED },
    { label: i18n.t('Running'), value: RUNNING },
    { label: i18n.t('Completed'), value: DONE },
    { label: i18n.t('Aborted'), value: ABORTED },
    { label: i18n.t('Failed'), value: FAILED },
  ]
  const selected = options.find((o) => o.value === filter)
  return (
    <AdvancedSelect
      name="filterByStatus"
      id="filterByStatus"
      label={i18n.t('Filter by status')}
      value={selected}
      options={options}
      onChange={(option) => onFilter(option?.value)}
      isClearable
      placeholder={<>{i18n.t('Filter...')}</>}
    />
  )
}

export const FilterByStatus = ({ filter, onFilter }: FilterByStatusProps) => (
  <FilterButton
    filter={filter}
    onFilter={onFilter}
    renderFilter={renderFilter}
  />
)
